/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_Offer_AcceptedInputs */

const tr_geliver_status_offer_accepted = /** @type {(inputs: Geliver_Status_Offer_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif kabul edildi`)
};

const en_geliver_status_offer_accepted = /** @type {(inputs: Geliver_Status_Offer_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer accepted`)
};

const de_geliver_status_offer_accepted = /** @type {(inputs: Geliver_Status_Offer_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot angenommen`)
};

const ru_geliver_status_offer_accepted = /** @type {(inputs: Geliver_Status_Offer_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложение принято`)
};

/**
* | output |
* | --- |
* | "Offer accepted" |
*
* @param {Geliver_Status_Offer_AcceptedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_offer_accepted = /** @type {((inputs?: Geliver_Status_Offer_AcceptedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_Offer_AcceptedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_offer_accepted(inputs)
	if (locale === "de") return de_geliver_status_offer_accepted(inputs)
	if (locale === "ru") return ru_geliver_status_offer_accepted(inputs)
	return tr_geliver_status_offer_accepted(inputs)
});